import React from "react";
import Intro from "./WebApplications/Intro";
import Services from "./WebApplications/WebServices";
import Projects from "./WebApplications/Projects";
import ClientTestimonials from "./WebApplications/Clients";
const ApplicationManagement = () => {


  return (
    <div>

      <Intro />
      < Services />
      <Projects />
      <ClientTestimonials/>
      <br />


    </div>
  );
};

export default ApplicationManagement;
